import { createContext, useContext } from 'react'
import { dark, SurfacePalette } from '../tokens'

/**
 * The ad editor's palette, for everything inside it. Dark unless the host says
 * otherwise, because packet review is dark; the Creatives gallery and the Sprints
 * tab open the same editor over light pages and supply `builder`.
 */
export const EditorPaletteContext = createContext<SurfacePalette>(dark)

export const useEditorPalette = () => useContext(EditorPaletteContext)
